import { RefCodeResolverBase } from './ref-code.resolver.base';
import { RefCodeService } from './ref-code.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class RefCodeResolver extends RefCodeResolverBase {

  constructor(protected service: RefCodeService) {
    super(service);
  }
}



